import React from "react";

// Renders editable copy with two dummy-proof conventions:
//   - a newline creates a line break
//   - **word** highlights that word in the brand lime
const renderAccents = (line) =>
  line.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <span key={i} className="text-[#5f8f10]">{part.slice(2, -2)}</span>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );

export const RichCopy = ({ text }) => {
  const lines = String(text || "").split("\n");
  return (
    <>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {i > 0 && <br />}
          {renderAccents(line)}
        </React.Fragment>
      ))}
    </>
  );
};
